import { isDateValid, parseDate } from "@lyfegen-platform/utils";
import format from "date-fns/format";
import { Maybe } from "../models/generated/graphql";

/**
 * @param v a date string or a date
 * @param dateFormat optional format according to date-fns/format, defaults to 'yyyy-MM-dd'
 */
const formatValidDate = (v?: Maybe<Date | string | null>, dateFormat?: string): Maybe<string> =>
	isDateValid(v) ? format(parseDate(v as any) as Date, dateFormat || "yyyy-MM-dd") : null;

export default formatValidDate;
